import React from 'react';
import ContactForm from '../contactform';
import LocationMap from '../location';

const Contact = () => {
  return (
    <div >
      <ContactForm />
      <LocationMap />
    </div>
  );
};

export default Contact;